import {QingApp} from "@/entity/QingApp";
import {Base} from "@/dto/Base";
import {ConsumerLightAppRelationReq} from "@/entity/ConsumerLightAppRelationReq";
import {QingAppRelationInfo} from "@/entity/QingAppRelationInfo";

export class ConsumerLightAppRelationDto {
    public static url = '/api/clac';

    public static async saveRelationInfo(consumerLightAppRelationReq: ConsumerLightAppRelationReq): Promise<ConsumerLightAppRelationReq>{
        const response = await Base.postWithToken(this.url + '/saveRelationInfo' ,consumerLightAppRelationReq);
        return response as  ConsumerLightAppRelationReq
    }
    public static async queryRelationInfo(qingAppRelationInfo: QingAppRelationInfo): Promise<QingApp[]>{
        const response = await Base.postWithToken(this.url + '/queryRelationInfo' ,qingAppRelationInfo)as any;
       const qingApp = response.data as QingApp[]
        return  qingApp
    }
    public static async  queryRelationInfoNotCommon(qingAppRelationInfo: QingAppRelationInfo): Promise<QingApp[]>{
        const response = await Base.postWithToken(this.url + '/queryRelationInfoNotCommon' ,qingAppRelationInfo)as any;
        const qingApp = response.data as QingApp[]
        return  qingApp
    }
}